module.exports = __webpack_public_path__ + "img/2.f5c6df7e.png";